<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择资产类型"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="assetModulesSpin">
      <a-card :bordered="false">
        <a-tree
          class="assetTreeModules"
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultCheckedKeys"
          :checkedKeys="checkedKeys"
          :treeData="seatchTreeData"
          :draggable="false"
          :defaultExpandedKeys="defaultExpandedKeys"
          @expand="onExpand"
          @check="select"
          checkable
        >
          <template slot="custom" slot-scope="item">
            <span class="assetTreeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getAssetTypeTreeList, getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  computed: {
    ...mapGetters(['assetAnlklArr'])
  },
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      seatchTreeData: [],
      defaultCheckedKeys: [],
      checkedKeys: [],
      defaultExpandedKeys: [],
      numberOfUpdates: 0
    }
  },
  created () {
    // 获取资产类型
    this.getAssetType()
  },
  methods: {
    ...mapActions(['handleAssetEchartsAnlkl']),
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    formateData (arr, id) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取资产类型
    async getAssetType () {
      const data = {
        pCode: 'zcfl',
        dimName: this.dimName
      }
      this.loading = true
      getAssetTypeTreeList().then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              item.id = item.code
              item.scopedSlots = { title: 'custom' }
              item.children = this.formateData(item.children, item.id)
            })
            if (this.dimName) {
              this.treeData = res.data
            } else {
              this.treeData = [
                {
                  id: '资产分类',
                  key: '资产分类',
                  scopedSlots: { title: 'custom' },
                  name: '资产',
                  code: '资产分类',
                  children: res.data
                }
              ]
            }
            // // 默认选中
            // this.defaultCheckedKeys = this.treeData[0].typeCode ? [this.treeData[0].typeCode] : [this.treeData[0].code]
            // // 指定选中
            // this.checkedKeys = this.treeData[0].typeCode ? [this.treeData[0].typeCode] : [this.treeData[0].code]
            // 默认选中
            this.defaultCheckedKeys = this.assetAnlklArr.anlkl === '空' ? [] : this.assetAnlklArr.anlkl
            // 指定选中
            this.checkedKeys = this.assetAnlklArr.anlkl === '空' ? [] : this.assetAnlklArr.anlkl
            // 指定展开
            this.defaultExpandedKeys = this.assetAnlklArr.anlkl === '空' ? [] : (this.assetAnlklArr.checkAll ? ['资产分类'] : this.assetAnlklArr.anlkl)
            this.handleAssetEchartsAnlkl({
              anlklList: this.checkedKeys,
              numberOfUpdates: this.numberOfUpdates++,
              anlklListLength: this.treeData.length
            })
          } else {
            this.treeData = []
            this.defaultCheckedKeys = []
            this.checkedKeys = []
          }
          this.seatchTreeData = this.treeData
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      this.checkedKeys = data
      this.handleAssetEchartsAnlkl({
        anlklList: data,
        numberOfUpdates: this.numberOfUpdates++,
        anlklListLength: this.treeData.length
      })
    },
    // 搜索设备分类
    queryDictData () {
      function fuzzySearch (str, obj) {
        var results = []
        for (var i = 0; i < obj.length; i++) {
          if (!obj[i].typeCode) {
            if (obj[i].name.indexOf(str) !== -1) {
              results.push(obj[i])
            }
          }
          if (obj[i].children) {
            results = results.concat(fuzzySearch(str, obj[i].children))
          }
        }
        return results
      }
      if (this.dimName) {
        this.seatchTreeData = fuzzySearch(this.dimName, this.treeData)
      } else {
        this.seatchTreeData = this.treeData
      }
      this.handleAssetEchartsAnlkl({
        anlklList: (this.checkedKeys.length === 1 && this.checkedKeys[0]) === '资产分类' ? '' : this.checkedKeys,
        numberOfUpdates: this.numberOfUpdates++,
        anlklListLength: this.treeData.length
      })
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.assetModulesSpin {
  height: calc(100% - 70px);
  overflow: auto;
}
.assetTreeCompanyName {
  font-size: 14px;
  margin-right: 25px;
  margin-top: 2px;
}
.assetTreeModules {
  overflow: hidden !important;
}
</style>
